module.exports = __webpack_public_path__ + "img/press-released.bbcfb49d.jpeg";